import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  Spinner,
  clearRefreshToken,
  setAccessToken,
  useAuth,
} from "@toss-ads/ui";

const IMP_ACTOR_KEY = "toss_ads.imp_actor";

// admin 의 '이 유저로 보기' → 새 탭으로 ?t=<token>&actor=<email> 으로 진입.
// 토큰을 메모리/세션에 박고 URL 에서 즉시 제거 (history 노출 방지) 후
// /auth/me 부트스트랩 한 뒤 /leads 로 이동.
export function ImpersonateCallback() {
  const navigate = useNavigate();
  const { refreshMe } = useAuth();
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("t");
    const actor = params.get("actor") ?? "";
    if (!token) {
      setError("토큰이 없습니다.");
      return;
    }

    setAccessToken(token);
    clearRefreshToken();
    try {
      sessionStorage.setItem(IMP_ACTOR_KEY, actor);
    } catch {
      /* 무시 */
    }
    // 토큰 URL 노출 최소화.
    window.history.replaceState(null, "", "/leads");

    void (async () => {
      const me = await refreshMe();
      if (!me) {
        setError("세션 시작에 실패했습니다.");
        return;
      }
      navigate("/leads", { replace: true });
    })();
  }, [navigate, refreshMe]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-canvas">
        <div className="text-[13px] text-danger">{error}</div>
      </div>
    );
  }
  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas text-ink-subtle">
      <Spinner size={24} />
    </div>
  );
}

export function getImpersonationActor(): string | null {
  try {
    return sessionStorage.getItem(IMP_ACTOR_KEY);
  } catch {
    return null;
  }
}

export function clearImpersonationActor(): void {
  try {
    sessionStorage.removeItem(IMP_ACTOR_KEY);
  } catch {
    /* 무시 */
  }
}
